import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-6 bg-white" data-id="element-130">
      <div className="max-w-3xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream/40 rounded-3xl p-8 md:p-10 border border-gold-light/40 shadow-soft flex flex-col md:flex-row items-center gap-6 text-center md:text-left relative overflow-hidden" data-id="element-132">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold-light/10 rounded-bl-full pointer-events-none" data-id="element-133"></div>

          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-full bg-white shadow-md flex items-center justify-center border-4 border-cream relative z-10" data-id="element-134">
            <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-gold-dark" strokeWidth={1.5} data-id="element-135" />
          </div>

          <div className="relative z-10" data-id="element-136">
            <h2 className="text-2xl md:text-3xl font-bold text-dark mb-2 font-serif" data-id="element-137">
              GARANTÍA DE 7 DÍAS SIN RIESGO
            </h2>
            <p className="text-base md:text-lg text-dark/80 leading-relaxed font-medium" data-id="element-138">
              Probala durante 7 días. Si sentís que no es para vos, podés
              solicitar la devolución del 100% de tu dinero sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}